/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {BaseComponent} from "@intuitionrobotics/thunderstorm/frontend";
import {DateTimesUtil} from "../../patients/DateTimesUtil";
import {
	backgroundCell,
	InboxTable
} from "../InboxTable";
import {COLORS} from "@res/colors";
import {
	CCInbox,
	MessageInfo_GetUnread
} from "@app/ir-q-app-common/types/message-api";

type Props = {
	chat: CCInbox | MessageInfo_GetUnread
	onClick: () => void
	isOpen: boolean
	getUnreadMessages: () => number
}

export class DateAndTimeCell
	extends BaseComponent<Props> {

	render() {
		const timestamp = this.props.chat.lastMessage?.timestamp;
		const unreadMessages = this.props.getUnreadMessages();

		let backgroundColor = "transparent";
		if (unreadMessages)
			backgroundColor = "#fffaf0";
		if (this.props.isOpen)
			backgroundColor = COLORS.primary_light_blue;

		return <div className={`ll_h_c ${backgroundCell(backgroundColor)}`} onClick={() => this.props.onClick()}>
			{InboxTable.rowStyle(DateTimesUtil.alertsPresentation(timestamp || 0), unreadMessages > 0)}
		</div>;
	}
}
